<!-- FAB Container with responsive classes -->
<div
	class="fab-container"
	[ngClass]="fabPositionClasses"
	#fabContainer
	[attr.aria-expanded]="state.isExpanded"
	[attr.aria-label]="primaryAction?.label || 'Actions menu'"
	role="button"
	tabindex="0"
>
	<!-- Primary FAB Button -->
	<button
		class="fab-button primary"
		#fabButton
		[disabled]="disabled || (primaryAction?.disabled && !hasSecondaryActions)"
		[class.loading]="state.isLoading"
		[class.has-menu]="hasSecondaryActions"
		(click)="onPrimaryActionClick()"
		[attr.aria-label]="primaryAction?.label || 'Primary action'"
		type="button"
	>
		<!-- Loading spinner -->
		<div class="loading-spinner" *ngIf="state.isLoading">
			<ion-spinner name="crescent" color="light"></ion-spinner>
		</div>

		<!-- Primary action icon -->
		<ion-icon *ngIf="!state.isLoading && primaryAction" [name]="primaryAction.icon" class="fab-icon primary-icon">
		</ion-icon>

		<!-- Default icon when no primary action -->
		<ion-icon *ngIf="!state.isLoading && !primaryAction" name="add-outline" class="fab-icon default-icon"> </ion-icon>

		<!-- Menu indicator for secondary actions -->
		<div class="menu-indicator" *ngIf="hasSecondaryActions && !state.isLoading">
			<ion-icon name="chevron-up-outline" [class.rotated]="state.isExpanded" class="menu-chevron"> </ion-icon>
		</div>
	</button>

	<!-- Menu Backdrop -->
	<div class="fab-backdrop" *ngIf="state.isExpanded" (click)="closeMenu()" [@fadeInOut]> </div>

	<!-- Expandable Menu -->
	<div
		class="fab-menu"
		*ngIf="hasSecondaryActions"
		[ngClass]="menuDirectionClass"
		[class.expanded]="state.isExpanded"
		[@menuAnimation]="state.isExpanded"
		role="menu"
		[attr.aria-hidden]="!state.isExpanded"
	>
		<!-- Secondary Actions -->
		<div class="fab-menu-section secondary-actions" *ngIf="secondaryActions.length > 0">
			<button
				class="fab-menu-item secondary"
				*ngFor="let action of secondaryActions; let i = index"
				[disabled]="action.disabled"
				[class.loading]="action.loading"
				[class.severity-danger]="action.color === 'danger'"
				[class.severity-warning]="action.color === 'warning'"
				[style.animation-delay]="i * 50 + 'ms'"
				(click)="onSecondaryActionClick(action)"
				[attr.aria-label]="action.label"
				[attr.title]="action.color"
				type="button"
				role="menuitem"
			>
				<!-- Action icon -->
				<ion-icon [name]="action.icon" class="menu-item-icon"></ion-icon>

				<!-- Action label (shown on larger screens) -->
				<span class="menu-item-label">{{ action.label }}</span>

				<!-- Loading spinner -->
				<ion-spinner *ngIf="action.loading" name="crescent" size="small" color="medium"> </ion-spinner>
			</button>
		</div>

		<!-- Separator between secondary and tertiary -->
		<div class="fab-menu-separator" *ngIf="secondaryActions.length > 0 && tertiaryActions.length > 0"> </div>

		<!-- Tertiary Actions -->
		<div class="fab-menu-section tertiary-actions" *ngIf="tertiaryActions.length > 0">
			<button
				class="fab-menu-item tertiary"
				*ngFor="let action of tertiaryActions; let i = index"
				[disabled]="action.disabled"
				[class.loading]="action.loading"
				[class.severity-danger]="action.color === 'danger'"
				[class.severity-warning]="action.color === 'warning'"
				[style.animation-delay]="(secondaryActions.length + i) * 50 + 'ms'"
				(click)="onSecondaryActionClick(action)"
				[attr.aria-label]="action.label"
				[attr.title]="action.color"
				type="button"
				role="menuitem"
			>
				<!-- Action icon -->
				<ion-icon [name]="action.icon" class="menu-item-icon"></ion-icon>

				<!-- Action label (shown on larger screens) -->
				<span class="menu-item-label">{{ action.label }}</span>

				<!-- Loading spinner -->
				<ion-spinner *ngIf="action.loading" name="crescent" size="small" color="medium"> </ion-spinner>
			</button>
		</div>
	</div>

	<!-- Primary Action Tooltip (Desktop only) -->
	<div class="fab-tooltip" *ngIf="isDesktop && primaryAction && !state.isExpanded" [class.visible]="showTooltip">
		{{ primaryAction.label }}
	</div>
</div>

<!-- Keyboard visible indicator (hidden, for CSS targeting) -->
<div class="keyboard-detector" [class.visible]="state.keyboardVisible" aria-hidden="true"> </div>
